<script>
export default {}
</script>

<template>
  <p><slot></slot></p>
</template>

<style scoped>
p {
  margin-top: 15px;
  color: gray;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
}
</style>